module.exports = __webpack_public_path__ + "static/media/psactions_original.bffd127b.jpg";